import type { SLIDER_DATA, SLIDER_PARAMS, SLIDER_PARAMS_DEVICE } from './types'

import { DEFAULT_PADDING, DEFAULT_WIDTH } from '../const'
import { DEFAULT_GENERAL_SLIDE_DATA, DEFAULT_GENERAL_SLIDE_PARAMS } from '../slide/general/const'

const DEFAULT_SLIDER_PARAMS_DEVICE = (): SLIDER_PARAMS_DEVICE => ({
  hidden: false,
  width: DEFAULT_WIDTH(),
  navigationPosition: 'bottom-left',
  slideCount: 1,
  padding: DEFAULT_PADDING(),
})

export const DEFAULT_SLIDER_PARAMS = (): SLIDER_PARAMS => ({
  navigation: true,
  navigationType: 'dots',
  pc: DEFAULT_SLIDER_PARAMS_DEVICE(),
  tablet: DEFAULT_SLIDER_PARAMS_DEVICE(),
  mobile: {
    ...DEFAULT_SLIDER_PARAMS_DEVICE(),
    navigationPosition: 'bottom-right',
  },
})

export const DEFAULT_SLIDER_DATA = (): SLIDER_DATA => ({
  id: null,
  type: 'slider',
  classes: null,
})

export const DEFAULT_SLIDER_GENERAL_SLIDE_CHILD = () => ({
  type: 'general-slide',
  params: DEFAULT_GENERAL_SLIDE_PARAMS(),
  data: DEFAULT_GENERAL_SLIDE_DATA(),
  children: [],
})

export const DEFAULT_SLIDER_CHILDS = () => [
  DEFAULT_SLIDER_GENERAL_SLIDE_CHILD(),
  DEFAULT_SLIDER_GENERAL_SLIDE_CHILD(),
  DEFAULT_SLIDER_GENERAL_SLIDE_CHILD(),
]